var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

/*! load-script2. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
module.exports = function loadScript2(src, attrs, parentNode) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.async = true;
    script.src = src;

    for (var _i = 0, _Object$entries = Object.entries(attrs || {}); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          k = _Object$entries$_i[0],
          v = _Object$entries$_i[1];

      script.setAttribute(k, v);
    }

    script.onload = function () {
      script.onerror = script.onload = null;
      resolve(script);
    };

    script.onerror = function () {
      script.onerror = script.onload = null;
      reject(new Error("Failed to load ".concat(src)));
    };

    var node = parentNode || document.head || document.getElementsByTagName('head')[0];
    node.appendChild(script);
  });
};